import React from 'react';

/**
 * Skeleton loader components for perceived instant performance
 */

export function SkeletonLine({ width = '100%', height = '16px', className = '' }) {
  return (
    <div
      className={`skeleton-line ${className}`}
      style={{ width, height }}
    />
  );
}

export function SkeletonBox({ width = '100%', height = '100px', className = '' }) {
  return (
    <div
      className={`skeleton-box ${className}`}
      style={{ width, height }}
    />
  );
}

export function LogsTabSkeleton() {
  return (
    <div className="logs-container">
      <div className="logs-header">
        <SkeletonLine width="180px" height="28px" />
        <SkeletonLine width="280px" height="16px" />
      </div>

      <div className="logs-filters">
        <SkeletonBox width="180px" height="36px" />
        <SkeletonBox width="140px" height="36px" />
      </div>

      <div className="workbench-card logs-table-container">
        <table className="workbench-table">
          <thead>
            <tr>
              <th><SkeletonLine width="80px" /></th>
              <th><SkeletonLine width="100px" /></th>
              <th><SkeletonLine width="60px" /></th>
              <th><SkeletonLine width="70px" /></th>
              <th><SkeletonLine width="50px" /></th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5].map(i => (
              <tr key={i}>
                <td><SkeletonLine width="120px" /></td>
                <td><SkeletonLine width="140px" /></td>
                <td><SkeletonLine width="40px" /></td>
                <td><SkeletonLine width="50px" /></td>
                <td><SkeletonLine width="45px" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function ApiKeysTabSkeleton() {
  return (
    <div className="keys-container">
      <div className="keys-header">
        <div>
          <SkeletonLine width="120px" height="28px" />
          <SkeletonLine width="280px" height="16px" />
        </div>
        <SkeletonBox width="140px" height="36px" />
      </div>

      <div className="workbench-card">
        <table className="workbench-table">
          <thead>
            <tr>
              <th><SkeletonLine width="60px" /></th>
              <th><SkeletonLine width="50px" /></th>
              <th><SkeletonLine width="80px" /></th>
              <th><SkeletonLine width="70px" /></th>
              <th><SkeletonLine width="60px" /></th>
              <th><SkeletonLine width="70px" /></th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3].map(i => (
              <tr key={i}>
                <td><SkeletonLine width="100px" /></td>
                <td><SkeletonLine width="80px" /></td>
                <td><SkeletonLine width="90px" /></td>
                <td><SkeletonLine width="90px" /></td>
                <td><SkeletonLine width="50px" /></td>
                <td><SkeletonLine width="90px" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function WebhooksTabSkeleton() {
  return (
    <div className="webhooks-container">
      <div className="webhooks-header">
        <div>
          <SkeletonLine width="120px" height="28px" />
          <SkeletonLine width="240px" height="16px" />
        </div>
        <SkeletonBox width="150px" height="36px" />
      </div>

      <div className="workbench-card">
        <table className="workbench-table">
          <thead>
            <tr>
              <th><SkeletonLine width="60px" /></th>
              <th><SkeletonLine width="50px" /></th>
              <th><SkeletonLine width="60px" /></th>
              <th><SkeletonLine width="60px" /></th>
              <th><SkeletonLine width="100px" /></th>
              <th><SkeletonLine width="70px" /></th>
            </tr>
          </thead>
          <tbody>
            {[1, 2].map(i => (
              <tr key={i}>
                <td><SkeletonLine width="100px" /></td>
                <td><SkeletonLine width="160px" /></td>
                <td><SkeletonLine width="70px" /></td>
                <td><SkeletonLine width="50px" /></td>
                <td><SkeletonLine width="100px" /></td>
                <td><SkeletonLine width="100px" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
